import { render, staticRenderFns } from "./sushi.vue?vue&type=template&id=0fee6ce0&scoped=true"
import script from "./sushi.vue?vue&type=script&lang=js"
export * from "./sushi.vue?vue&type=script&lang=js"
import style0 from "./sushi.vue?vue&type=style&index=0&id=0fee6ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fee6ce0",
  null
  
)

export default component.exports